import { moneyWithCurrencyProvided } from '@/filters';

const ACTIVE_CURRENCY = window?.Shopify?.currency?.active ?? 'USD';
const SHOW_CURRENCY_NAME = false;
const REMOVE_TRAILING_ZEROS = true;

export const updateProductPrices = (currentVariant, product) => {
    if (!product || !currentVariant) {
        return;
    }

    const product_price_widgets = document.querySelectorAll(`[data-product-prices="${ product.id }"]`);
    if (!product_price_widgets?.length) {
        return;
    }

    function updateSubscriptionPrice(container) {
        const node = container.querySelector('[data-subscription-price]');
        if (!node) {
            return;
        }

        const subscription_price = product.subscription_duplicate?.variants?.find((variant) => variant.title === currentVariant.title)?.price;
        if (!subscription_price) {
            return;
        }

        node.innerHTML = moneyWithCurrencyProvided(subscription_price, ACTIVE_CURRENCY, SHOW_CURRENCY_NAME, REMOVE_TRAILING_ZEROS);
    }

    function updateMemberPrice(container) {
        const node = container.querySelector('[data-member-price]');
        if (!node) {
            return;
        }

        const member_multiply_discount_value = Number(node.dataset.memberPrice);
        if (!member_multiply_discount_value) {
            return;
        }

        node.innerHTML = moneyWithCurrencyProvided(currentVariant.price * member_multiply_discount_value, ACTIVE_CURRENCY, SHOW_CURRENCY_NAME, REMOVE_TRAILING_ZEROS);
    }

    function updateRetailPrice(container) {
        const node = container.querySelector('[data-retail-price]');
        if (!node) {
            return;
        }

        node.innerHTML = moneyWithCurrencyProvided(currentVariant.price, ACTIVE_CURRENCY, SHOW_CURRENCY_NAME, REMOVE_TRAILING_ZEROS);
    }

    function updateSalePrice(container) {
        const sale_prices_container = container.querySelector('[data-sale-price-container]');
        const sale_prices_retail_container = container.querySelector('[data-sale-retail-price-container]');
        if (!sale_prices_container || !sale_prices_retail_container) {
            return;
        }

        if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
            sale_prices_container.classList.remove('hide');
            sale_prices_retail_container.classList.add('hide');
            
            const node = sale_prices_container.querySelector('[data-sale-price]');
            if (!node) {
                return;
            }

            node.innerHTML = moneyWithCurrencyProvided(currentVariant.price, ACTIVE_CURRENCY, SHOW_CURRENCY_NAME, REMOVE_TRAILING_ZEROS);

            const node_percent = sale_prices_container.querySelector('[data-sale-discount-percent]');
            if (!node_percent) {
                return;
            }

            node_percent.innerHTML = `${ 100 - Math.round(currentVariant.price / currentVariant.compare_at_price * 100) }`;

            const node_retail_sale = sale_prices_container.querySelector('[data-sale-retail-price]');
            if (!node_retail_sale) {
                return;
            }
            node_retail_sale.innerHTML = moneyWithCurrencyProvided(currentVariant.compare_at_price, ACTIVE_CURRENCY, SHOW_CURRENCY_NAME, REMOVE_TRAILING_ZEROS);
            return;
        }
        
        const node_retail = sale_prices_retail_container.querySelector('[data-sale-retail-price]');
        if (!node_retail) {
            return;
        }

        sale_prices_container.classList.add('hide');
        sale_prices_retail_container.classList.remove('hide');
        node_retail.innerHTML = moneyWithCurrencyProvided(currentVariant.price, ACTIVE_CURRENCY, SHOW_CURRENCY_NAME, REMOVE_TRAILING_ZEROS);
    }

    function updatePricesNoSub(container) {
        const retail_price_node = container.querySelector('[data-retail-price-no-sub]');
        const sale_price_node = container.querySelector('[data-sale-price-no-sub]');

        if (!retail_price_node || !sale_price_node) {
            return;
        }

        retail_price_node.innerHTML = moneyWithCurrencyProvided(currentVariant.price, ACTIVE_CURRENCY, SHOW_CURRENCY_NAME, REMOVE_TRAILING_ZEROS);

        if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
            sale_price_node.classList.remove('hide');
            sale_price_node.innerHTML = moneyWithCurrencyProvided(currentVariant.compare_at_price, ACTIVE_CURRENCY, SHOW_CURRENCY_NAME, REMOVE_TRAILING_ZEROS);
            return;
        }

        sale_price_node.classList.add('hide');
    }

    product_price_widgets.forEach((product_price_widget) => {
        updateSubscriptionPrice(product_price_widget);
        updateMemberPrice(product_price_widget);
        updateRetailPrice(product_price_widget);
        updateSalePrice(product_price_widget);
        updatePricesNoSub(product_price_widget);
    });
}

export default {
    updateProductPrices
}
